import { Profile as HygraphProfileProps } from '@/lib/types';

import { textToContent } from '@/components/hygraph-rich-text';
import { LinkProps } from '@/components/link';
import { ProfileProps } from '@/components/profile';

import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';

export default function profileTransformer(
  props: HygraphProfileProps
): ProfileProps {
  return {
    name: props.name || undefined,
    caption: props.title || undefined,
    body: props.content ? textToContent(props.content) : undefined,
    image: props.headshot ? hygraphImageTransformer(props.headshot) : undefined,
    type: props.type || undefined,
    link: {
      href: props.linkedInUrl || '',
      icon: undefined,
    } as LinkProps,
  };
}
